/** Aircraft position providers offered in the forms, and their live status (GET /api/providers, cached). */
import { useEffect, useState } from 'react';
import type { AircraftProviderId, ProviderStatus } from '@apos/shared';
import { api } from '../../lib/api';

export const PROVIDERS: Array<{ id: AircraftProviderId; label: string }> = [
  { id: 'public', label: 'Automatic tracking (recommended)' },
  { id: 'crew_device', label: 'A crew phone on board' },
  { id: 'adsb', label: 'ADS-B (same data source as automatic)' },
  { id: 'flightaware', label: 'Keyed providers · shoot owner’s sources' },
  { id: 'manual', label: 'Manual positions' },
  { id: 'companion', label: 'iOS companion' },
];

const providerCache = new Map<string, Promise<ProviderStatus[]>>();
/** Forget cached statuses (e.g. after the AeroAPI key changes in My settings). */
export function clearProviderCache(): void {
  providerCache.clear();
}

/** With a shoot id, FlightAware reports that shoot owner's key (what crew on the shoot actually get). */
export function useProviders(missionId?: string): ProviderStatus[] {
  const [list, setList] = useState<ProviderStatus[]>([]);
  useEffect(() => {
    let alive = true;
    const key = missionId ?? '';
    let p = providerCache.get(key);
    if (!p) {
      p = api.providers(missionId).catch(() => {
        providerCache.delete(key);
        return [];
      });
      providerCache.set(key, p);
    }
    void p.then((l) => alive && setList(l));
    return () => {
      alive = false;
    };
  }, [missionId]);
  return list;
}
